import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useTheme } from '@mui/material/styles';

const MapCluster = dynamic(() => import('components/Maps/MapCluster'), {
  ssr: false,
});

export default function CountryMapPosts({ bbox, countryCode }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch(`/api/map-posts?countryCode=${countryCode}`)
      .then(res =>
        res.json().then(result => {
          if (result && result.posts) {
            setPosts(result.posts);
          }
        }),
      )
      .catch(err => {
        console.log(err);
      });
  }, []);

  const theme = useTheme();

  if (!posts || posts.lengt === 0) return <></>;
  return (
    <div
      className="tw-relative tw-rounded-xl tw-overflow-hidden tw-col-span-3 tw-mt-1 tw-mx-1 md:tw-mt-0 md:tw-mx-0 tw-h-128"
      id="container"
    >
      <MapCluster
        data={posts}
        dark={theme.palette.mode === 'dark'}
        bbox={bbox}
        showControls={false}
        getWidthFromContainer
        scrollZoom={false}
      />
    </div>
  );
}
